/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        template: `
from datetime import *
`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `

def datetime_timestamp_seconds(timestamp):
    return datetime_timestamp_mins(timestamp) * 60 + (timestamp % 60)

def datetime_timestamp_mins(timestamp):
    days = 0
    mins = 0
    secs = 0
    mins_offset = 0
    td_get_tzone_offset(APP_TIMEZONE, mins_offset)
    datetime_from_timestamp(timestamp + mins_offset * 60, days, mins, secs)
    return mins

def datetime_mins_to_timestamp(mins):
    #timestamp = datetime_current_timestamp()
    #datetime_days, datetime_minutes, datetime_secs = datetime_from_timestamp(timestamp)
    #datetime_minutes = mins
    #datetime_days, datetime_minutes = td_local_to_gmt(datetime_days, datetime_minutes, APP_TIMEZONE, PL_OFF)
    #return datetime_to_timestamp(datetime_days, datetime_minutes, 0)
    return time.mktime((1970,1,1,0,int(mins),0,0,0))
`,
    });
    return blocks;
};
